<template lang="">
  <v-app>
      <v-container fluid>
          <v-card elevation="0">
              <v-card-title>
                  <span class="display-1">Históricos</span>
                  <v-spacer></v-spacer>
              </v-card-title>
              <!--TABS-->
              <div class="mb-4 mt-2 pl-3 pr-3">
                
                  <history ></history>
              </div>
          </v-card>
      </v-container>
</v-app>
</template>
<script>
import History from "@/components/History.vue";
import { mapActions } from 'vuex';

export default {
data() {
  return {
    tipoEnsayo: 0,
  }
},
components:{
  History, 
},
methods: {
  ...mapActions('api',['getUltimoTratamiento']),
  cargarUltimoTratamiento(){
    console.log("mostramos el ultimo tratamiento");
  }
},
};
</script>
